import React, { useContext, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-final-form";
import * as yup from "yup";
import Papa from "papaparse";
import { Grid } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import { DataGrid, GridCellEditStopReasons } from "@mui/x-data-grid";
import { GridSingleSelectColDef } from "@mui/x-data-grid";
import UiSwitch from "../../../_uiMocks/_uiComponents/UiSwitch";
import {
     UiButton,
     UiButtonDataManagement,
} from "../../../_uiComponents/common/form/UiButton";
import ImportedRecords from "./ImportedRecords";
import {
     contextApiActions,
     factTableConstants,
} from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";
import UiSelect from "../../../_uiMocks/_uiComponents/UiSelect";
import {
     factTableTypesRequest,
     factTableAddRequest,
     factTableUpdateRequest,
     factTableGetAllSchemeAttributeRequest,
     factTableGetAllSchemaTypeRequest,
     lookupTableListRequest,
     ajaxError,
     factTableCreateByCsvUploadRequest,
} from "../../../../_redux/_actions";
import UiCheckbox from "../../../_uiComponents/common/form/UiCheckBox";
import UiInput from "../../../_uiComponents/UiInput";
import Validator from "../../../../_helpers/validate.schema";

const validateSchema = () =>
     yup.object().shape({
          name: yup.string().required("Name is required."),

          columnList: yup
               .array()
               .min(1, "At least one column required.")
               .required("Csv file is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function CreateByFileImport(props) {
     const [state, dispatch] = useContext(Context);
     const [rowSelectionModel, setRowSelectionModel] = useState([]);
     const [checked, setChecked] = useState(true);
     const [lookUpTableShow, setLookupTableShow] = useState(false);
     const [tableRows, setTableRows] = useState([]);
     const [firstRowIsHeader, setFirstRowIsHeader] = useState(true);
     const [csvFormatedData, setCsvFormatedData] = useState([]);

     const buttonRef = useRef(null);
     const inputTypeFileRef = useRef(null);

     const actionDispatch = useDispatch();

     const { schemeAttribute, schemaType, lookupTableList } = useSelector(
          (state) => {
               return {
                    schemeAttribute: state.factTable.schemeAttribute,
                    schemaType: state.factTable.schemaType,
                    lookupTableList: state.lookupTable.list.data,
               };
          },
     );

     useEffect(() => {
          actionDispatch(factTableGetAllSchemeAttributeRequest());
          actionDispatch(factTableGetAllSchemaTypeRequest());
          actionDispatch(
               lookupTableListRequest({
                    page: 1,
                    pageSize: 100,
               }),
          );
     }, []);

     const VisuallyHiddenInput = styled("input")({
          clip: "rect(0 0 0 0)",
          clipPath: "inset(50%)",
          height: 1,
          overflow: "hidden",
          position: "absolute",
          bottom: 0,
          left: 0,
          whiteSpace: "nowrap",
          width: 1,
     });

     const columns = [
          {
               field: "column_name",
               headerName: "Column Name",
               width: 180,
               height: 62,
               type: "text",
               editable: true,
               align: "left",
               sortable: false,
               filterable: false,
               disableColumnMenu: true,
               hideable: false,
               resizable: false,
          },
          {
               field: "formatted_column_name",
               headerName: "Formatted Column Name",
               width: 200,
               height: 62,
               type: "text",
               editable: false,
               align: "left",
               sortable: false,
               filterable: false,
               disableColumnMenu: true,
               hideable: false,
               resizable: false,
          },

          {
               field: "type",
               headerName: "Type",
               align: "center",
               headerAlign: "center",
               width: 280,
               sortable: false,
               filterable: false,
               disableColumnMenu: true,
               hideable: false,
               resizable: false,
               renderCell: (params, test) => {
                    return (
                         <>
                              <div
                                   className="sba-fact-type-wr"
                                   key={params.row.id}
                              >
                                   <div className="sba-fact-type-wr__left-col">
                                        <UiSelect
                                             key={params.row.id}
                                             label="Type"
                                             options={schemaType.map((type) => {
                                                  return {
                                                       value: type.id,
                                                       label: type.name,
                                                  };
                                             })}
                                             handleChange={(event) => {
                                                  typeChange(event, params);
                                             }}
                                             value={params.row.typeId}
                                        />
                                   </div>

                                   {params.row.typeCode == "LOOKUP_TABLE" && (
                                        <div className="sba-fact-type-wr__right-col">
                                             <UiSelect
                                                  label="Look up table"
                                                  options={lookupTableList.map(
                                                       (lookupTable) => {
                                                            return {
                                                                 value: lookupTable.id,
                                                                 label: lookupTable.name,
                                                            };
                                                       },
                                                  )}
                                                  handleChange={(event) => {
                                                       typeChangeLookupTable(
                                                            event,
                                                            params,
                                                       );
                                                  }}
                                                  value={
                                                       params.row.lookupTableId
                                                  }
                                             />
                                        </div>
                                   )}
                              </div>
                         </>
                    );
               },
          },

          {
               field: "attribute",
               headerName: "Attribute",
               align: "center",
               headerAlign: "center",
               width: 150,
               height: 62,
               sortable: false,
               filterable: false,
               disableColumnMenu: true,
               hideable: false,
               resizable: false,
               renderCell: (params) => (
                    <UiSelect
                         label="Attribute"
                         options={schemeAttribute.map((type) => {
                              return {
                                   value: type.id,
                                   label: type.name,
                              };
                         })}
                         handleChange={(event) => {
                              typeChangeAttribute(event, params);
                         }}
                    />
               ),
          },
          {
               field: "identity",
               headerName: "Identity",
               align: "center",
               headerAlign: "center",
               width: 150,
               height: 62,
               sortable: false,
               filterable: false,
               disableColumnMenu: true,
               hideable: false,
               resizable: false,
               renderCell: (params) => {
                    return (
                         <UiSwitch
                              checked={params.row.identity}
                              onClick={(event) => {
                                   identityHandleChange(event, params);
                              }}
                         />
                    );
               },
          },

          {
               field: "mandatory",
               headerName: "Mandatory",
               align: "center",
               headerAlign: "center",
               width: 150,
               height: 62,
               sortable: false,
               filterable: false,
               disableColumnMenu: true,
               hideable: false,
               resizable: false,
               renderCell: (params) => (
                    <UiSwitch
                         checked={params.row.mandatory}
                         onClick={(event) => {
                              mondotoryHandleChange(event, params);
                         }}
                    />
               ),
          },
          {
               field: "filterable",
               headerName: "Filterable",
               align: "center",
               headerAlign: "center",
               width: 150,
               height: 62,
               sortable: false,
               filterable: false,
               disableColumnMenu: true,
               hideable: false,
               resizable: false,
               renderCell: (params) => (
                    <UiSwitch
                         checked={params.row.filterable}
                         onClick={(event) => {
                              filterableHandleChange(event, params);
                         }}
                    />
               ),
          },

          {
               field: "delete",
               headerName: "",
               align: "center",
               headerAlign: "center",
               width: 80,
               sortable: false,
               filterable: false,
               disableColumnMenu: true,
               hideable: false,
               resizable: false,
               renderCell: (params) => (
                    <IconButton
                         onClick={(event) => {
                              handleDelete(event, params);
                         }}
                    >
                         <DeleteIcon className="sb-table-row-delete" />
                    </IconButton>
               ),
          },
     ];

     const processRowUpdate = (newRow, event) => {
          const rowIndexToUpdate = tableRows.findIndex(
               (row) => row.id === newRow.id,
          );

          if (rowIndexToUpdate !== -1) {
               const newData = [...tableRows];
               newData.splice(rowIndexToUpdate, 1, newRow);

               const rows = newData.map((column, index) => ({
                    id: index + 1,
                    column_name: column?.column_name,
                    name: column?.column_name.replace(/ /g, "_"),
                    formatted_column_name: column?.column_name.replace(
                         / /g,
                         "_",
                    ),
                    typeCode: column?.typeCode,
                    // values: column?.values,
                    identity: column.identity,
                    mandatory: column.mandatory,
                    filterable: column.filterable,
                    lookupTableId: column.lookupTableId ? column.lookupTableId : null,
                    typeId: column?.typeId,
                    attributeId: column?.attributeId,

                    labels: ["string"],
               }));

               setTableRows(rows);
          }

          return response;
     };

     const typeChange = (event, params) => {
          event.stopPropagation();

          const typeObj = schemaType.find(
               (obj) => obj.id === event.target.value,
          );

          let rowTableNew = tableRows;

          rowTableNew[params.row.id - 1].typeId = typeObj.id;
          rowTableNew[params.row.id - 1].typeCode = typeObj.code;

          setTableRows([...rowTableNew]);
     };

     const typeChangeLookupTable = (event, params) => {
          event.stopPropagation();

          let rowTableNew = tableRows;

          rowTableNew[params.row.id - 1].lookupTableId = event.target.value;

          setTableRows([...rowTableNew]);
     };

     const typeChangeAttribute = (event, params) => {
          event.stopPropagation();

          let rowTableNew = tableRows;

          rowTableNew[params.row.id - 1].attributeId = event.target.value;

          setTableRows([...rowTableNew]);
     };

     const handleFileImport = () => {
          dispatch({
               type: contextApiActions.UI_EXTRA_LARGE_MODAL_TOGGEL,
               payload: {
                    show: true,
                    children: <ImportedRecords />,
               },
          });
     };

     const mondotoryHandleChange = (event, params) => {
          event.stopPropagation();

          let newRows = tableRows.map((tableRow, index) => {
               if (params.row.id == index + 1) {
                    tableRow.mandatory = event.target.checked;

                    if (tableRow.identity) {
                         tableRow.mandatory = true;
                    }
               }

               return tableRow;
          });

          setTableRows(newRows);
     };

     const filterableHandleChange = (event, params) => {
          event.stopPropagation();
          let newRows = tableRows.map((tableRow, index) => {
               if (params.row.id == index + 1) {
                    tableRow.filterable = event.target.checked;

                    if (tableRow.identity) {
                         tableRow.filterable = true;
                    }
               }

               return tableRow;
          });

          setTableRows(newRows);
     };

     const identityHandleChange = (event, params) => {
          event.stopPropagation();

          let newRows = tableRows.map((tableRow, index) => {
               if (params.row.id == index + 1) {
                    tableRow.identity = event.target.checked;
                    if (event.target.checked) {
                         tableRow.mandatory = true;
                    }
               } else {
                    tableRow.identity = false;
               }

               return tableRow;
          });

          setTableRows(newRows);
     };

     const csvFileUploader = (data) => {
          const file = data?.target?.files[0];
          if (file?.type === factTableConstants.CSV_FILE_TYPE) {
               Papa.parse(file, {
                    header: true,
                    dynamicTyping: true,
                    complete: function (results) {
                         const columns = results.meta.fields;
                         const rowsData = results.data;

                         const rows = columns.map((column, index) => ({
                              id: index + 1,
                              // name: column,
                              column_name: firstRowIsHeader ? column : "",
                              formatted_column_name: firstRowIsHeader
                                   ? column.replace(/ /g, "_")
                                   : "",
                              // total_records: rowsData.filter(
                              //      (row) =>
                              //           row[column] !== null &&
                              //           row[column] !== undefined,
                              // ).length,
                              // values: rowsData
                              //     .map((row) => row[column])
                              //     .filter(
                              //         (value) =>
                              //             value !== null &&
                              //             value !== undefined,
                              //     ),
                              identity: false,
                              mandatory: false,
                              filterable: false,
                              labels: ["string"],
                         }));

                         setCsvFormatedData(rows);
                         setTableRows(rows);
                    },
                    error: function (error) {
                         console.error("CSV parsing error:", error);
                    },
               });
          }
     };
     function CustomNoRowsOverlay() {
          return <div className="sba-no-data-row">No Data</div>;
     }

     const setDefault = () => {
          inputTypeFileRef.current = null;
          setTableRows([]);
     };

     const firstRowChecked = (event) => {
          if (event.target.checked) {
               setFirstRowIsHeader(true);
               setTableRows(csvFormatedData);
          } else {
               const rows = tableRows.map((column, index) => ({
                    id: index + 1,
                    column_name: `column_${index + 1}`,
                    name: `column_${index + 1}`,
                    formatted_column_name: `column_${index + 1}`,
                    typeCode: column?.typeCode,
                    identity: column.identity,
                    mandatory: column.mandatory,
                    filterable: column.filterable,
                    lookupTableId: column.lookupTableId,
                    typeId: column?.typeId,
                    attributeId: column?.attributeId,
                    labels: [],
               }));
               setTableRows(rows);
               setFirstRowIsHeader(false);
          }
     };

     const submit = async (values, form) => {
          let validationError = false;

          let val = values.columnList.filter((column) => {
               let ex = false;
               // rowSelectionModel.every((id) => {
               //      if (id == column.id) {
               //           ex = true;

               //           return false;
               //      }

               //      return true;
               // });

               return true;
          });

          if (val.length == 0) {
               actionDispatch(
                    ajaxError({
                         message: "ajax error 400",
                         name: "AjaxError",
                         response: {
                              statusCode: "0107052024",
                              message: ["Please select at least one row"],
                              error: "Service error",
                         },

                         status: 400,
                    }),
               );

               return;
          }

          val.every((column) => {
               if (column.column_name == "") {
                    actionDispatch(
                         ajaxError({
                              message: "ajax error 400",
                              name: "AjaxError",
                              response: {
                                   statusCode: "0207052024",
                                   message: ["Validation failure"],
                                   error: "Service error",
                              },

                              status: 400,
                         }),
                    );
                    validationError = true;
                    return false;
               }

               if (!column.typeId) {
                    actionDispatch(
                         ajaxError({
                              message: "ajax error 400",
                              name: "AjaxError",
                              response: {
                                   statusCode: "0207052024",
                                   message: [
                                        "Please select Type of each selected row",
                                   ],
                                   error: "Service error",
                              },

                              status: 400,
                         }),
                    );
                    validationError = true;
                    return false;
               }

               return true;
          });

          let formatedValues = val.map((column) => {
               return {
                    name: column.formatted_column_name,
                    dataTypeId: column.typeId,
                    lookupTableId: column.lookupTableId
                         ? column.lookupTableId
                         : 0,
                    attributeId: column.attributeId ? column.attributeId : 0,
                    identity: column.identity,
                    mandatory: column.mandatory,
                    filterable: column.filterable,
               };
          });

          const payload = {
               name: values.name,
               columnList: formatedValues,
               setDefault: setDefault,
               form,
          };

          if (!validationError) {
               actionDispatch(factTableCreateByCsvUploadRequest(payload));
          }

          // props.getIncentiveTableList({ ...values });

          // payload.attributeList.every((attribute) => {
          //           const attributeId = attribute.id;

          //           const attrObject =
          //                state$.value.factTable.schemeAttribute.find(
          //                     (attr) => attr.id === attributeId,
          //                );
          //           let attrCount = 0;
          //           state$.value.factTable.tableValueList.data.forEach(
          //                (element) => {
          //                     element.attributeList.forEach((att) => {
          //                          if (att.id == attrObject.id) ++attrCount;
          //                     });
          //                },
          //           );

          //           if (attrCount < attrObject.occurrence) {
          //                return true;
          //           }

          //           attrObj = attrObject;
          //           callRequest = false;
          //           return false;
          //      });
     };

     const handleAdd = () => {
          const newRow = {
               column_name: `column_${tableRows.length + 1}`,
               formatted_column_name: `column_${tableRows.length + 1}`,
               id: tableRows.length + 1,
               identity: false,
               labels: ["string"],
               mandatory: false,
          };

          const newRows = [...tableRows];
          newRows.push(newRow);
          setTableRows(newRows);
     };

     const handleDelete = (event, params) => {
          dispatch({
               type: contextApiActions.UI_CONFIRMATION_TOGGEL,
               payload: {
                    show: true,
                    okFunction: () => {
                         let newValues = tableRows
                              .filter(function (obj) {
                                   return obj.id !== params.row.id;
                              })
                              .map(function (val, index) {
                                   val.id = index + 1;
                                   return val;
                              });

                         setTableRows(newValues);
                    },
               },
          });
     };

     return (
          <>
               <Grid
                    container
                    spacing={2}
                    sx={{ mt: 1 }}
                    className="sba-ft-form-wr"
               >
                    <Grid
                         item
                         xs={12}
                         lg={12}
                         className="sba-create-by-file-import-top-heading"
                    >
                         <Button
                              component="label"
                              role={undefined}
                              variant="contained"
                              tabIndex={-1}
                              startIcon={<CloudUploadIcon />}
                         >
                              Upload file
                              <VisuallyHiddenInput
                                   ref={inputTypeFileRef}
                                   type="file"
                                   accept=".csv"
                                   onChange={(e) => csvFileUploader(e)}
                              />
                         </Button>
                         <p className="sba-csv-upload-comment">
                              Only CSV (Comma separated values) files are
                              allowed and the file size should not exceed 10MB.{" "}
                         </p>
                    </Grid>

                    {tableRows?.length !== 0 && (
                         <>
                              <Form
                                   onSubmit={submit}
                                   validate={onValidate}
                                   mutators={{
                                        setFormAttribute: (
                                             [fieldName, fieldVal],
                                             state,
                                             { changeValue },
                                        ) => {
                                             changeValue(
                                                  state,
                                                  fieldName,
                                                  () => fieldVal,
                                             );
                                        },
                                   }}
                                   render={({
                                        form,
                                        handleSubmit,
                                        ...formValues
                                   }) => {
                                        return (
                                             <form onSubmit={validateSchema}>
                                                  <>
                                                       <div className="sba-table-head-instructions">
                                                            <UiCheckbox
                                                                 label="First row is header"
                                                                 checked={
                                                                      firstRowIsHeader
                                                                 }
                                                                 handleChange={(
                                                                      e,
                                                                 ) => {
                                                                      firstRowChecked(
                                                                           e,
                                                                      );
                                                                 }}
                                                            />
                                                            <div className="sba-header-top-detials-wr">
                                                                 <div className="sba-header-top-detials-wr__top">
                                                                      <div className="sba-fact-table-input">
                                                                           <UiInput
                                                                                label="Fact table name"
                                                                                name="name"
                                                                                allowedCharacters={
                                                                                     /^[a-zA-Z0-9_ ]+$/
                                                                                }
                                                                           />
                                                                      </div>
                                                                      <span>
                                                                           To
                                                                           create
                                                                           the
                                                                           fact
                                                                           table,
                                                                           please
                                                                           select
                                                                           the
                                                                           required
                                                                           columns.
                                                                      </span>
                                                                 </div>
                                                                 <div className="sb-add-row-btn">
                                                                      <UiButtonDataManagement
                                                                           name="Add Fact Table Row"
                                                                           variant="contained"
                                                                           onClick={
                                                                                handleAdd
                                                                           }
                                                                      />
                                                                 </div>
                                                            </div>

                                                            <button
                                                                 ref={buttonRef}
                                                                 className="sba-hidden-btn"
                                                                 onClick={(
                                                                      event,
                                                                 ) => {
                                                                      event.preventDefault();
                                                                      if (
                                                                           tableRows.length >
                                                                           0
                                                                      ) {
                                                                           form.mutators.setFormAttribute(
                                                                                "columnList",
                                                                                tableRows,
                                                                           );
                                                                      }

                                                                      setTimeout(
                                                                           () => {
                                                                                handleSubmit();
                                                                           },
                                                                           1,
                                                                      );
                                                                 }}
                                                            />
                                                       </div>
                                                  </>
                                                  {form.getState()
                                                       .submitFailed &&
                                                       formValues.errors
                                                            .columnList && (
                                                            <FormHelperText className="sba-form-error">
                                                                 {
                                                                      formValues
                                                                           .errors
                                                                           .columnList
                                                                 }
                                                            </FormHelperText>
                                                       )}
                                             </form>
                                        );
                                   }}
                              />
                              <Grid
                                   item
                                   xs={12}
                                   lg={12}
                                   className="sba-data-grid-wr-comp sba-auto-datagrid-tbl"
                              >
                                   <DataGrid
                                        rows={tableRows}
                                        columns={columns}
                                        processRowUpdate={processRowUpdate}
                                        // checkboxSelection
                                        // onRowSelectionModelChange={(
                                        //      newSelection,
                                        // ) => {
                                        //      setRowSelectionModel(newSelection);
                                        // }}
                                        slots={{
                                             noRowsOverlay: CustomNoRowsOverlay,
                                        }}
                                        hideFooterPagination
                                        hideFooter
                                        pagination={true}
                                        pageSize={5}
                                   />
                              </Grid>
                              <Grid item xs={12} lg={12}>
                                   <Stack
                                        spacing={2}
                                        direction="row"
                                        justifyContent="end"
                                        sx={{
                                             width: "100%",
                                             mt: 3,
                                        }}
                                   >
                                        <UiButton
                                             name="Import"
                                             variant="contained"
                                             size="small"
                                             // disabled={
                                             //      tableRows?.length ===
                                             //      0
                                             // }
                                             onClick={(event) => {
                                                  event.preventDefault();
                                                  buttonRef.current.click();
                                             }}
                                        />
                                   </Stack>
                              </Grid>
                         </>
                    )}
               </Grid>
          </>
     );
}
